
import Vue from 'vue'
import Router from 'vue-router'

//PAGES
import DefaultTemplate from '../pages/DefaultTemplate'
import Admin from '../components/Admin'
import Home from '../components/Home'
import User from '../components/User'
import Setting from '../components/Setting'
import Public from '../components/Public'
import PageNotFound from '../components/PageNotFound'

Vue.use(Router)

import KeycloakUtils from '../keycloakUtils'

const route = (path,name,meta, component) => {
  return {
    path,
    name,
    meta,
    component: () => import(`../components/${component}`)
  }
}



const router = new Router({
  routes: [
    {
      path: '/',
      component: DefaultTemplate,
      redirect: 'home/principal',
      children:[
        {
          path: 'home',
          component: Home,
          children:[
            route('principal','home.principal',  {requiresAuth: false}, 'home/Principal'),

          ]
        },
        {
          path: 'admin',
          component: Admin,
          redirect:'admin/Usuarios',
          children: [
            route('administrar','admin.administrar', {requiresAuth: true}, 'admin/Administrar'),
            route('usuarios','admin.usuarios', {requiresAuth: true}, 'admin/Usuarios'),
            route('consola','admin.consola', {requiresAuth: true}, 'admin/Intranet'),
            route('informe','admin.informe', {requiresAuth: true}, 'admin/Informe'),
            route('usuario','admin.usuarios', {requiresAuth: true}, 'admin/Usuarios'),
          ]
        },
        {
          path: 'user',
          component: User,
          redirect:'user/intranet/:code',
          children: [
            route('intranet/:code','user.intranet', {requiresAuth: true}, 'user/Intranet'),
            route('noticia/:code','user.noticia', {requiresAuth: true}, 'user/Noticia'),
          ]
        },
        {
          path: 'setting',
          component: Setting,
          redirect:'setting/account',
          children: [
            route('account','setting.account', {requiresAuth: true}, 'setting/Account'),
            route('change','setting.change', {requiresAuth: true}, 'setting/Changepass'),
          ]
        },
        {
          path: 'public',
          component: Public,
          redirect:'public/noticia/88',
          children: [
            route('noticia/:code','public.noticia', {requiresAuth: false}, 'public/Noticia'),

          ]
        }
      ]
    },

    { path: "*", component: PageNotFound }

  ],
  linkActiveClass: "is-active",
  scrollBehavior: () => ({ y: 0 }),
})



router.beforeEach((to, from, next) => {

  if (to.meta.requiresAuth) {
    KeycloakUtils.validateSesion(window.keycloak).then(data=>{
      next()
    })
  }
  else {
    next()
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js